import { create } from 'zustand';
import { makeGet, makePatch, makePost } from '../../utils/call-api-endpoint';
import type { PaginatedList } from '../common/padinated-list';
import {
  toQueryString,
  type PaginationQueryParamsWithStatus
} from '../common/pagination-query-params';
import { useUIStore } from '../ui/ui.store';
import type { GrupoArticulos } from './grupo-articulos';

export interface GruposArticulosState {
  list: PaginatedList<GrupoArticulos>;
  current: GrupoArticulos;
  actives: GrupoArticulos[];

  nuevo: () => void;
  cargarPaginados: (params: PaginationQueryParamsWithStatus) => Promise<void>;
  cargarActivos: () => Promise<void>;
  cargarPorId: (id: number) => Promise<void>;
  registrar: (request: RegistrarGrupoArticulos) => Promise<boolean>;
  actualizar: (id: number, request: ActualizarGrupoArticulos) => Promise<boolean>;
  eliminar: (id: number) => Promise<boolean>;
}

export interface RegistrarGrupoArticulos {
  nombre: string;
}

export interface ActualizarGrupoArticulos {
  nombre: string;
}

const { showSuccessToast } = useUIStore.getState();

export const useGrupoArticulosStore = create<GruposArticulosState>()((set, get) => ({
  list: {
    items: [],
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0
  },
  current: {} as GrupoArticulos,
  actives: [],

  nuevo: () =>
    set({
      current: {} as GrupoArticulos
    }),
  cargarPaginados: async (params: PaginationQueryParamsWithStatus) => {
    const data = await makeGet<PaginatedList<GrupoArticulos>>(
      `/grupos-articulos/paginados?${toQueryString(params)}`
    );

    if (data.isFailure) return;

    set({
      list: data.result
    });
  },
  cargarActivos: async () => {
    const data = await makeGet<Array<GrupoArticulos>>('/grupos-articulos/activos');

    if (data.isFailure) return;

    set({
      actives: data.result
    });
  },
  cargarPorId: async (id: number) => {
    const data = await makeGet<GrupoArticulos>(`/grupos-articulos/${id}`);

    if (data.isFailure) return;

    set({
      current: data.result
    });
  },
  registrar: async (request: RegistrarGrupoArticulos) => {
    const data = await makePost<RegistrarGrupoArticulos, GrupoArticulos>(
      '/grupos-articulos/',
      request
    );

    if (data.isFailure) return false;

    showSuccessToast('Registro agregado');

    set({
      current: {} as GrupoArticulos
    });

    return true;
  },
  actualizar: async (id: number, request: ActualizarGrupoArticulos) => {
    const data = await makePatch<ActualizarGrupoArticulos, GrupoArticulos>(
      `/grupos-articulos/${id}`,
      request
    );

    if (data.isFailure) return false;

    showSuccessToast('Registro actualizado');

    set({
      current: {
        ...get().current,
        ...request
      }
    });

    return true;
  },
  eliminar: async (id: number) => {
    const data = await makePatch(`/grupos-articulos/${id}/eliminar`);

    if (data.isFailure) return false;

    showSuccessToast('Registro eliminado');

    set({
      current: {} as GrupoArticulos
    });

    return true;
  }
}));
